import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

import { DataHubCard } from '../../DataHubCard';
import Preview from '../Preview';

export const PreviewCard = () => {
  const { exportSettings } = useExportSettings();
  if (exportSettings.exportType === ExportTypes.IMAGE) {
    return (
      <DataHubCard
        icon={<ChartBoxMultipleOutline sx={{ fontSize: '16px' }} />}
        subtitle='Preview visualization before exporting'
        title='Preview'
      >
        <Preview />
      </DataHubCard>
    );
  }
  return null;
};
